<template>
  <v-dialog :value="value" @input="$emit('input', $event)" no-click-animation persistent scrollable width="620">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Nueva solicitud de documento</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click="close" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0 background-card">
        <v-list class="py-4 transparent">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text--secondary font-weight-medium">Cliente</v-list-item-title>
              <v-list-item-subtitle class="pl-1" v-if="!form.customer || !form.customer.id">
                <v-col cols="8" class="py-1 px-0">
                  <v-btn @click="dialogCustomer=true" outlined :ripple="false"><v-icon left>mdi-plus</v-icon>Seleccionar un cliente</v-btn>
                </v-col>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-else>
                <v-row no-gutters align="center" class="py-1">
                  <v-col cols="6">
                    <span class="body-2 text--secondary font-weight-medium">{{form.customer.name}}</span>
                  </v-col>
                  <v-col cols="6" class="pl-2">
                    <v-btn @click="dialogCustomer=true" outlined color="secondary">Cambiar...</v-btn>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text--secondary font-weight-medium">Tipo</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="6" class="py-1 px-0">
                  <v-select v-model="$v.form.submission_type.$model" :error="$v.form.submission_type.$error" :items="submissionTypes" item-value="id" item-text="name" background-color="white" outlined single-line dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text--secondary font-weight-medium">Fecha límite</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="4" class="py-1 px-0">
                  <v-menu v-model="datePickers.dueDate" :close-on-content-click="false" transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="$v.form.due_date.$model" :error="$v.form.due_date.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                        <template v-slot:append>
                          <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="$v.form.due_date.$model" @input="datePickers.dueDate=false" type="date" :min="today" :first-day-of-week="1" locale="es-cl" width="280" color="primary" no-title />
                  </v-menu>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text--secondary font-weight-medium">Destinatarios</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="12" class="py-1 px-0">
                  <v-combobox
                    v-model="$v.form.recipients.$model"
                    :error="$v.form.recipients.$error"
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    background-color="white"
                    outlined
                    dense
                    hide-details
                    placeholder="Escribe emails y presiona Enter"
                    append-icon=""
                  />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text--secondary font-weight-medium">Asunto del email (opcional)</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="12" class="py-1 px-0">
                  <v-text-field v-model.trim="form.email_subject" maxlength="200" background-color="white" outlined single-line dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text--secondary font-weight-medium">Mensaje (opcional)</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="12" class="py-1 px-0">
                  <v-textarea v-model.trim="form.email_message" rows="3" auto-grow background-color="white" outlined dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn @click="close" outlined>Cancelar</v-btn>
        <v-spacer />
        <v-btn @click="save" :loading="$store.state.supportingDocuments.createLoader" color="primary">Crear solicitud</v-btn>
      </v-card-actions>
    </v-card>

    <customer-picker-dialog v-model="dialogCustomer" @select="setCustomer" />
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import CustomerPickerDialog from '@/components/supporting-documents/CustomerPickerDialog'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const defaultForm = () => ({
  customer: null,
  submission_type: 'order',
  due_date: '',
  recipients: [],
  email_subject: '',
  email_message: ''
})

const allEmails = (list) => Array.isArray(list) && list.length > 0 && list.every(v => typeof v === 'string' && EMAIL_RE.test(v.trim()))

export default {
  components: {
    CustomerPickerDialog
  },
  mixins: [
    GenericViewMixin
  ],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    datePickers: {
      dueDate: false
    },
    dialogCustomer: false,
    form: defaultForm(),
    submissionTypes: [
      { id: 'order', name: 'Orden de compra (OC)' },
      { id: 'hes', name: 'Hoja de entrada de servicio (HES)' }
    ]
  }),
  computed: {
    today () {
      return new Date().toISOString().slice(0, 10)
    }
  },
  watch: {
    value (open) {
      if (open) this.reset()
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    reset () {
      this.form = defaultForm()
      this.$v.$reset()
    },
    setCustomer (customer) {
      this.form.customer = customer
    },
    save () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return

      const payload = {
        customer: this.form.customer.id,
        submission_type: this.form.submission_type,
        due_date: this.form.due_date,
        recipients: this.form.recipients.map(e => String(e).trim())
      }
      if (this.form.email_subject) payload.email_subject = this.form.email_subject
      if (this.form.email_message) payload.email_message = this.form.email_message

      this.$store.dispatch('supportingDocuments/CREATE', {
        resource: 'supporting-documents/submission-requests',
        payload,
        commitInstance: false
      })
      .then((response) => {
        this.$dialog.message.success('Solicitud creada correctamente')
        this.$emit('created', response.data)
        this.close()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    form: {
      customer: { required },
      submission_type: { required },
      due_date: { required },
      recipients: {
        required,
        allEmails
      }
    }
  }
}
</script>
